import React from 'react';
import { MessageCircle, Stethoscope, HeartPulse, Sparkles } from 'lucide-react';
import './ProcessMap.css';

const ProcessMap = () => {
  const steps = [
    { id: 1, title: "İlk Tanışma", desc: "Sıcak bir karşılamayla muayene sürecini başlatıyoruz.", icon: <MessageCircle />, color: "#4FBDBA", pos: "left" },
    { id: 2, title: "Hassas İnceleme", desc: "Akademik birikim ve klinik tecrübemizle titiz analizler yapıyoruz.", icon: <Stethoscope />, color: "#FFB347", pos: "right" },
    { id: 3, title: "Modern Tedavi", desc: "En güncel cerrahi tekniklerle iyileşme adımı.", icon: <HeartPulse />, color: "#F06292", pos: "left" },
    { id: 4, title: "Mutlu Gülümseme", desc: "Sağlığımıza tam güvenle kavuşuyoruz.", icon: <Sparkles />, color: "#7ED957", pos: "right" }
  ];

  return (
    <section className="process-area">
      <div className="process-header">
        <h2>İyileşme Yolculuğumuz</h2>
        <p>Adım adım çocuğunuzun yanındayız.</p>
      </div>
      <div className="map-container">
        <div className="mobile-line"></div>
        <div className="map-path-svg">
          <svg width="100%" height="100%" viewBox="0 0 400 800" fill="none" preserveAspectRatio="none">
            <path d="M200,0 C200,100 350,150 350,250 C350,350 50,450 50,550 C50,650 200,700 200,800" stroke="#e0e7e7" strokeWidth="4" strokeDasharray="10 10"/>
          </svg>
        </div>
        <div className="steps-wrapper">
          {steps.map(s => (
            <div key={s.id} className={`step-node ${s.pos}`}>
              <div className="step-box" style={{ "--clr": s.color }}>
                <div className="step-icon">{s.icon}<span className="step-num">{s.id}</span></div>
                <div className="step-info"><h3>{s.title}</h3><p>{s.desc}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessMap;